import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    avgPayHeader: () =>
        __('Gennemsnitsløn'),
    avgPayDefinitionHeader: () =>
        __('Om gennemsnitsløn'),
    avgPayDefinition: () =>
        __('På grafen kan du se, hvordan virksomhedens gennemsnitsløn ligger sammenlignet med 10 lignende virksomheder. Gennemsnitslønnen er inklusiv bonusordninger men ikke pension.'),
    avgPayDisclaimer: () =>
        __('Gennemsnitslønnen er et pejlemærke og der tages forbehold for unøjagtigheder og er derfor ikke et godt værktøj til lønforhandling etc. '),
    readMore: () =>
        __('Læs mere'),
    avgPayChartTitle: () =>
        __('Sammenlign gennemsnitsløn med lignende virksomheder'),
    avgPayYAxis: () =>
        __('Lønindeks'),
    avgPayXAxis: () =>
        __('Virksomheder'),

    avgPayModalHeader: () =>
        __('Gennemsnitslønninger'),
    avgPayModalDataHeader: () =>
        __('Hvordan udregnes gennemsnitsløn?'),
    avgPayModalDataExplain: () =>
        __('Gennemsnitslønnen udregnes ved at dividere lønomkostninger med antal medarbejdere normaliseret for tid. Data er hentet fra virk.dk.'),
    avgPayModalComparisonHeader: () =>
        __('Sammenlignelige virksomheder'),
    avgPayModalComparisonExplain: () =>
        __('Virksomheder der ligner er baseret på hvad brugere på jobindex klikker på.'),

    reportHeader: (companyname) =>
        __x('{companyname} regnskab', { companyname }),
    reportExplain: (companyname) =>
        __x('Se regnskabet for {companyname} her. Det giver dig en god mulighed for at få et overblik og dykke ned i de seneste års omsætning, fortjeneste og resultat.', { companyname }),
    reportChartTitle: () =>
        __('Omsætning, fortjeneste og resultat'),
    reportChartRevenue: () =>
        __('Omsætning'),
    reportChartIncome: () =>
        __('Bruttofortjeneste'),
    reportChartResult: () =>
        __('Årets resultat'),
};
